//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IFdeLicenseDetailsData {
    'serials': string[];
    'licensesConsumed': number;
    'maxSsd': number;
}

@Component({
    selector: 'app-fde-license-details',
    templateUrl: './fde-license-details.component.html',
    styleUrl: './fde-license-details.component.scss',
    standalone: false
})
export class FdeLicenseDetailsComponent {
  serials: string;
  licensesConsumed: number;
  constructor(@Inject(MAT_DIALOG_DATA) public data: IFdeLicenseDetailsData,
              private readonly dialogRef: MatDialogRef<IFdeLicenseDetailsData>
              ) {
    this.serials = [...data.serials].sort().join(', ');
    this.licensesConsumed = data.licensesConsumed;
  }

  onCloseClick() {
        this.dialogRef.close();
  }
}
